import React from "react";
import { Globe, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { LANGUAGES } from "@/lib/languages";
import TEXTS from "@/lib/langBanner.json";
import { Select, SelectContent, SelectItem, SelectTrigger } from "@/components/ui/select";

export function DetectedLangBanner() {
  const { t } = useLang();
  const { lang, setLang, detectedNotice, dismissDetectedNotice } = useLang();
  if (!detectedNotice) return null;
  const txt = TEXTS[lang] || TEXTS.en;
  return (
    <div className="relative z-[60] bg-findo-navy text-white text-xs sm:text-sm" data-testid="detected-lang-banner">
      <div className="max-w-6xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2">
        <Globe size={14} className="shrink-0 opacity-80" />
        <span data-testid="detected-lang-banner-text">{txt.shown} —</span>
        <Select value={lang} onValueChange={setLang}>
          <SelectTrigger className="h-auto w-auto border-0 bg-transparent p-0 text-xs sm:text-sm font-semibold underline underline-offset-2 shadow-none focus:ring-0 [&>svg]:hidden" data-testid="detected-lang-banner-change">
            {txt.change}
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {LANGUAGES.map((l) => (
              <SelectItem key={l.code} value={l.code} data-testid={`banner-lang-${l.code}`}>
                <span className="flex items-center gap-2"><span>{l.flag}</span> {l.name}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <button onClick={dismissDetectedNotice} className="ml-2 opacity-70 hover:opacity-100" aria-label={t("hc.close")} data-testid="detected-lang-banner-close">
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
